module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "content-wrapper"
  }, [(_vm.display) ? _c('question') : _vm._e(), _vm._v(" "), (_vm.isVisibleErrorsModal) ? _c('errors') : _vm._e(), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.purchasingNote || _vm.loading) ? _c('spinner') : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-lg-12"
  }, [_c('onboarding-wizard', {
    attrs: {
      "userStatus": _vm.userStatus
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('h4', {
    staticClass: "text-center form-title"
  }, [_vm._v("Purchase Community Investment Note")]), _vm._v(" "), _c('form', {
    attrs: {
      "role": "form",
      "novalidate": ""
    }
  }, [_c('div', {
    staticClass: "form-group form-group-element"
  }, [_c('label', [_vm._v("Enter investment amount")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "money",
      rawName: "v-money",
      value: (_vm.money),
      expression: "money"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.investmentAmount),
      expression: "investmentAmount"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ({
        required: true
      }),
      expression: "{required: true}"
    }],
    class: {
      'form-control text-right input-md': true, 'form-control-error': _vm.isInvestmentAmountInvalid
    },
    attrs: {
      "autocomplete": "off",
      "name": "investmentAmount",
      "id": "investmentAmount",
      "required": ""
    },
    domProps: {
      "value": (_vm.investmentAmount)
    },
    on: {
      "change": _vm.removeNegative,
      "blur": function($event) {
        _vm.validateInvestmentAmount()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.investmentAmount = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.isInvestmentAmountInvalid) ? _c('span', {
    staticClass: "error-feedback"
  }, [_vm._v(_vm._s(_vm.investmentAmountError))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-element"
  }, [_c('label', [_vm._v("Select rate and term")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.interestYearRateSelected),
      expression: "interestYearRateSelected"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "name": "account",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.interestYearRateSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.interestYearRates), function(interest) {
    return _c('option', {
      domProps: {
        "value": interest.id
      }
    }, [_vm._v(_vm._s(interest.label))])
  })), _vm._v(" "), _c('div', {
    staticClass: "has-feedback",
    class: {
      'has-error': _vm.interestYearRateErrorMessage
    }
  }, [_c('strong', {
    staticClass: "help-block",
    attrs: {
      "id": "helpBlock6"
    }
  }, [_vm._v(_vm._s(_vm.interestYearRateErrorMessage))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-group-element"
  }, [_c('label', [_vm._v("Select bank account")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fundingSourceSelected),
      expression: "fundingSourceSelected"
    }],
    staticClass: "form-control input-lg",
    attrs: {
      "name": "account",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.fundingSourceSelected = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.fundingSources), function(account) {
    return _c('option', {
      domProps: {
        "value": account.id
      }
    }, [_vm._v(_vm._s(account.name))])
  })), _vm._v(" "), _c('div', {
    staticClass: "has-feedback",
    class: {
      'has-error': _vm.fundingSourceErrorMessage
    }
  }, [_c('strong', {
    staticClass: "help-block",
    attrs: {
      "id": "helpBlock6"
    }
  }, [_vm._v(_vm._s(_vm.fundingSourceErrorMessage))])])]), _vm._v(" "), _c('div', {
    staticClass: "checkbox c-checkbox check-margin"
  }, [_c('label', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.dwollaTermsCheck),
      expression: "dwollaTermsCheck"
    }],
    attrs: {
      "type": "checkbox",
      "value": "",
      "name": "agreeTerms"
    },
    domProps: {
      "checked": Array.isArray(_vm.dwollaTermsCheck) ? _vm._i(_vm.dwollaTermsCheck, "") > -1 : (_vm.dwollaTermsCheck)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.dwollaTermsCheck,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.dwollaTermsCheck = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.dwollaTermsCheck = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.dwollaTermsCheck = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "fa fa-check"
  }), _vm._v(" "), _c('terms-of-conditions')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "has-feedback",
    class: {
      'has-error': _vm.prospectusAndDwollaTermsErrorMessage
    }
  }, [_c('strong', {
    staticClass: "help-block",
    attrs: {
      "id": "helpBlock6"
    }
  }, [_vm._v(_vm._s(_vm.prospectusAndDwollaTermsErrorMessage))])])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default btn-lg",
    attrs: {
      "type": "submit",
      "disabled": _vm.isSubmitButtonDisabled()
    },
    on: {
      "click": function($event) {
        _vm.validateAndSubmitInvestment()
      }
    }
  }, [_vm._v("\n                  Submit\n                ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  })])])])], 1)], 1)], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-heading"
  }, [_vm._v("\n      Manage investments\n      "), _c('small', {
    attrs: {
      "data-localize": "dashboard.WELCOME"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-header"
  }, [_c('div', {
    staticClass: "panel-title"
  }, [_vm._v("Make an investment")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-292ebcf5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PurchaseNote.vue
// module id = 2128
// module chunks = 1